// User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const LOGOUT = "LOGOUT";
export const AUTH = "AUTH";
export const GET_SALDO = "GET_SALDO";
export const ADD_OPERACAO = "ADD_OPERACAO";